import { graphql } from "@/graphql/generated/gql";

// ============== QUERIES ======================
export const getLabelGroupListForWorkspaceQueryDocument = graphql(/* GraphQL */ `
  query GetLabelGroupListForWorkspace($input: GetLabelGroupListForWorkspaceInput!) {
    labelGroupListForWorkspace(getLabelGroupListForWorkspaceInput: $input) {
      ...LabelGroupFields
    }
  }
`);

export const getLabelGroupQueryDocument = graphql(/* GraphQL */ `
  query GetLabelGroup($input: GetLabelGroupInput!) {
    labelGroup(getLabelGroupInput: $input) {
      ...LabelGroupFields
    }
  }
`);

// ============== MUTATIONS ======================
export const createLabelGroupMutationDocument = graphql(/* GraphQL */ `
  mutation createLabelGroup($input: CreateLabelGroupInput!) {
    createLabelGroup(createLabelGroupInput: $input) {
      ...LabelGroupFields
    }
  }
`);

export const updateLabelGroupMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateLabelGroup($input: UpdateLabelGroupInput!) {
    updateLabelGroup(updateLabelGroupInput: $input) {
      ...LabelGroupFields
    }
  }
`);

export const deleteLabelGroupMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteLabelGroup($input: DeleteLabelGroupInput!) {
    deleteLabelGroup(deleteLabelGroupInput: $input) {
      ...LabelGroupFields
    }
  }
`);
